<div class="mech-diag-content">
	@if (confidence) {
		<div class="confidence">Prediction confidence: {{confidence}}</div>
	}
	<app-dvs-chart [error]="errormessage" [options]="options" [height]="'400px'" [timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
	@if (hasMaintenance) {
		<div class="chart-legend">
			<span class="legend-item">
				<span class="swatch adjustment"></span> Maintenance event
			</span>
		</div>
	}
	<div class="trend-options">
		<div class="row justify-content-sm-center">
			<div class="col-sm-auto">
				<div class="form-check">
					<label>
						<input [(ngModel)]="useXAxisDate" (ngModelChange)="RefreshChart()" type="checkbox">
						X-Axis by date
					</label>
				</div>
			</div>
			@if (dataExceedsLimit) {
				<div class="col-sm-auto">
					<div class="form-check">
						<label title="Chart is normally limited to the last 15k points. Viewing all data may cause your browser to crash.">
							<input [(ngModel)]="unlimitedChart" (ngModelChange)="RefreshChart()" type="checkbox">
							Show all data
						</label>
					</div>
				</div>
			}
			<div class="col-sm-auto">
				<div class="form-check">
					<label>
						<input [(ngModel)]="forceRul" (ngModelChange)="RefreshChart()" type="checkbox">
						Force RUL calculation
					</label>
				</div>
			</div>
			@if (forceRul && rul) {
				<div class="col-sm-auto">
					RUL: {{rul | number : "1.0-2"}}
				</div>
			}
		</div>
	</div>
</div>